import { render, staticRenderFns } from "./card-product-spec-item-cmp.vue?vue&type=template&id=570bfc7f&scoped=true"
import script from "./card-product-spec-item-cmp.vue?vue&type=script&lang=js"
export * from "./card-product-spec-item-cmp.vue?vue&type=script&lang=js"
import style0 from "./card-product-spec-item-cmp.vue?vue&type=style&index=0&id=570bfc7f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570bfc7f",
  null
  
)

export default component.exports